import { fetchApi } from "../DataApi/fetchApi";

export async function sessionAuth() {
  const myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Content-Type", "application/json");

  const params = {};
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({ params }),
    credentials: "include",
  };

  try {
    let response = await fetchApi({
      requestOptions,
      endpoint: `/web/session/get_session_info`,
      headers: myHeaders,
      checkSession: false,
    });

    response = JSON.parse(response);
    return response;
  } catch (error) {
    return error;
  }
}
